import React from 'react';
import { Flex, Link } from '@applyboard/crystal-ui';
import { ChevronRightOutlineIcon } from '@applyboard/ui-icons';
import { useEventTracker } from '@applyboard/ui-utils';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export var LearnMoreSection = function LearnMoreSection(_ref) {
  var path = _ref.path,
    eventTrackingOptions = _ref.eventTrackingOptions;
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  return _jsx(Flex, {
    justify: "end",
    children: _jsx(Link, {
      as: "a",
      saliency: "default",
      href: path,
      trailIcon: ChevronRightOutlineIcon,
      variant: "standalone",
      onClick: function onClick() {
        var _eventTrackingOptions;
        trackEvent({
          event: "".concat((_eventTrackingOptions = eventTrackingOptions === null || eventTrackingOptions === void 0 ? void 0 : eventTrackingOptions.eventsPrefix) !== null && _eventTrackingOptions !== void 0 ? _eventTrackingOptions : '', "Scholarship Card - Clicked Learn More"),
          data: eventTrackingOptions === null || eventTrackingOptions === void 0 ? void 0 : eventTrackingOptions.eventTrackingData
        });
      },
      children: "Learn more"
    })
  });
};